import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
  children: React.ReactNode;
}

export const Button: React.FC<ButtonProps> = ({ 
  variant = 'primary', 
  children, 
  className = '', 
  ...props 
}) => {
  const baseStyles = "font-mono text-sm uppercase tracking-wider px-6 py-3 transition-all duration-300 ease-out border focus:outline-none focus:ring-1 focus:ring-emerald";
  
  const variants = {
    primary: "border-white/20 text-white hover:border-emerald hover:text-emerald hover:shadow-[0_0_15px_rgba(0,255,65,0.1)] active:scale-[0.98] bg-transparent backdrop-blur-sm",
    secondary: "border-transparent text-mutedGray hover:text-white"
  };

  return (
    <button 
      className={`${baseStyles} ${variants[variant]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};